export enum NotEligibleReasonDto {
    None,
    TrialWasUsed,
    CreditCardWasUsed,
}

export interface ITrialEligibilityDto {
    isEligible: boolean;
    notEligibleReason: NotEligibleReasonDto;
    promoCode: string;
}

export const notEligibleResErrors = {
    0: 'Promo.Trial.NotEligible',
    1: 'Promo.Trial.TrialWasUsed',
    2: 'Promo.Trial.CreditCardIsNotEligible',
};
